import { render, staticRenderFns } from "./dialog-save-role.vue?vue&type=template&id=7ba90864&scoped=true&"
import script from "./dialog-save-role.vue?vue&type=script&lang=js&"
export * from "./dialog-save-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba90864",
  null
  
)

export default component.exports